






















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Utils } from '@/helper/utils';
import { Base } from './base';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import { typetimeout } from '@/directives/input';
import { mask } from 'vue-the-mask';

@Component({
    directives: {
        mask,
        typetimeout,
    },
    computed: {
        dateRangeText: {
            get() {
                if (!this.dates[0] && !this.dates[1]) {
                    return this.dates.join(' ~ ');
                }
                if (this.dates[0] && !this.dates[1]) {
                    this.minDate = _dateTime.currentDate(new Date(this.dates[0]));
                    const lastdate = _dateTime.addDays(new Date(this.minDate), this.maxDiff);
                    const lastDateFormatted = _dateTime.currentDate(new Date(lastdate));
                    if (this.IsDateFuture) {
                        const currentSelectedMinDate = _dateTime.currentDate(new Date(this.dates[0]));
                        const lastdateAsSelection = _dateTime.addDays(new Date(currentSelectedMinDate), this.maxDiff);
                        const lastDateFormat = _dateTime.currentDate(new Date(lastdateAsSelection));

                        const todayCurrentDate = _dateTime.currentDate(new Date());
                        const setLastDate = _dateTime.addDays(new Date(todayCurrentDate), this.maxDiff);
                        const setLastDateFormatted = _dateTime.currentDate(new Date(setLastDate));
                        if (lastDateFormat < setLastDateFormatted) {
                            this.todayDate = lastDateFormat;
                        } else {
                            this.todayDate = setLastDateFormatted;
                        }


                    } else {
                        if (lastDateFormatted < this.todayDate) {
                            this.todayDate = lastDateFormatted;
                            this.flags.showDatePicker = true;
                        }
                    }
                } else {
                    this.todayDate = _dateTime.currentDate(new Date());
                }
                this.$emit('setDates', this.dates);
                return this.dates.join(' ~ ');
            },
            set() {
                // empty block
            },
        },
    },
    props: [
        'label',
        'name',
        'fromDate',
        'endDate',
        'difference',
        'max',
        'isDefaultDateRangeDisabled',
        'isResetFilter',
        'isDateFieldEditable',
        'IsFutureDate',
    ],
})
export default class CalendarComponent extends Base {
    public dates: any[] = [];
    public todayDate: string = _dateTime.currentDate(new Date());
    public minDate: any = null;
    public dateRangeText: string;
    public maxDiff: number = 30;
    public readOnly: boolean = true;
    public validateRule: boolean = true;
    public IsDateFuture: boolean = false;

    public flags: any = {
        showDatePicker: false,
    };
    public params: any = {
        startDate: '',
        endDate: '',
    };
    public created(): void {
        this.params.startDate = this.$props.fromDate ? this.presentDate(this.$props.fromDate) : this.presentDate();
        this.params.endDate = this.$props.endDate ? this.presentDate(this.$props.endDate) : this.presentDate();
    }

    public mounted() {
        this.$watch('isResetFilter', (newVal, oldVal) => {
            this.resetDateFilter();
            return;
        });
        if (this.$props.IsFutureDate) {
            this.IsDateFuture = true;

        }
        if (this.$props.isDateFieldEditable) {
            this.readOnly = false;
        }

        if (this.$props.isDefaultDateRangeDisabled) {
            if (this.$props.fromDate && this.$props.endDate) {
                this.dates = [
                    this.presentDate(this.$props.fromDate),
                    this.presentDate(this.$props.endDate)
                ];
            } else {
                this.dates = [];
            }
        }else {
            if (this.$props.difference) {
                this.maxDiff = Number(this.$props.difference);
            }

            if (this.$props.fromDate && this.$props.endDate) {
                this.params.startDate = this.presentDate(this.$props.endDate);
                this.minDate = this.presentDate(this.$props.fromDate);
                this.dates = [this.minDate, this.params.startDate];
            } else {
                const lastdate = this.subtractDaysFromPresent(this.maxDiff, this.params.startDate);
                this.minDate = this.presentDate(lastdate);
                this.dates = [this.minDate, this.params.startDate];
            }
        }
    }

    public closeCalendar(): void {
        if (this.dates && this.dates.length > 1) {
            this.flags.showDatePicker = false;
        } else {
            this.flags.showDatePicker = true;
        }
    }
    public clearSearchDate(): void {
        if (this.dates && this.dates.length > 1) {
            this.minDate = null;
            if (this.IsDateFuture) {
                const minDated = _dateTime.currentDate(new Date());
                const lastdate = _dateTime.addDays(new Date(minDated), this.maxDiff);
                const lastDateFormatted = _dateTime.currentDate(new Date(lastdate));
                this.todayDate = lastDateFormatted;
            } else {
                this.todayDate = _dateTime.currentDate(new Date());
            }

        }
    }
    public resetDateFilter() {
        this.dates = [];
        this.dates.join(' ~ ');
        this.minDate = null;
        this.$emit('reset');
    }

    public validateDate(dateValue) {
        let dateArray: any[] = [];
        let returnvalue = false;
        const elementValue = dateValue.srcElement.value;
        if (!elementValue.includes('~')) {
            this.validateRule = false;
            return returnvalue = false;

        }
        dateArray = elementValue.split('~');
        const re = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        const validateStartDate = re.test(String(dateArray[0]));
        const validateEndDate = re.test(String(dateArray[1]));
        if (validateStartDate && validateEndDate) {
            if (dateArray[1] < dateArray[0]) {
                this.showAlert(false, this.$t('appCalendar.alertEndDateMustNotSmallerThanStartDate'));
                this.validateRule = false;
                return returnvalue = false;
            }
            if (dateArray[0] > this.todayDate || dateArray[1] > this.todayDate) {
                this.showAlert(false, this.$t('appCalendar.alertStartDateEndDateMustNotGreaterThanTodayDate'));
                this.validateRule = false;
                return returnvalue = false;
            }
            this.dates = dateArray;
            this.$emit('setDates', this.dates);
            returnvalue = true;
            this.validateRule = true;
        } else {
            returnvalue = false;
            this.validateRule = false;
        }
        return returnvalue;
    }
}

